import { styled } from 'baseui'

export const CommentsScrollContainer = styled('div', {
  height: '250px',
})

export const CommentsLoadingContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  padding: '2rem',
})

export const CommentRowContainer = styled('div', {
  display: 'contents',
})

export const CommentText = styled('span', {
  fontSize: '0.75rem',
  fontStyle: 'italic',
})

export const CommentMetaLabel = styled('span', {
  display: 'block',
  width: '100%',
  textAlign: 'right',
  fontSize: '0.75rem',
  fontWeight: 'bold',
})

export const CommentActionsRow = styled('div', {
  display: 'flex',
  gap: '0.5rem',
  marginTop: '0.25rem',
})

export const AbandonWarningText = styled('span', ({ $theme }) => ({
  display: 'block',
  color: $theme.colors.errorInput,
  fontWeight: 'bold',
  marginBottom: '1rem',
}))
